import { TeamLeaderboardPage } from "@fwa/src/components/TeamLeaderboardPage";
import Head from "next/head";

const Page = () => (
  <>
    <Head>
      <meta name="robots" content="noindex" />
    </Head>
    <TeamLeaderboardPage />
  </>
);

export default Page;
